import { object, string } from "yup";
import { stringExists } from "./helpers";

export const DDAFeeAccountInformationSchema = object().shape({
  businessName: stringExists,
  address: stringExists,
  phone: stringExists,
  bankName: stringExists,
  bsbNumber: string().matches(/^\d{6}$/, "Please enter a 6-digit number without hyphens, spaces or special characters"),
  accountNumber: stringExists,
  accountHolderName: stringExists,
  accountHolderTitle: stringExists,
});